module.exports = __webpack_public_path__ + "img/programming.7d5ea583.png";